import { create } from "zustand";

export type TPendingEODStore = {
  refetchCountPendingEOD: number;
  onRefetchPendingEOD: () => void;
};

export const usePendingEODStore = create<TPendingEODStore>((set) => ({
  refetchCountPendingEOD: 0,
  onRefetchPendingEOD: () => {
    set((state) => ({
      ...state,
      refetchCountPendingEOD: state.refetchCountPendingEOD + 1,
    }));
  },
}));
